export default __webpack_public_path__ + "static/media/fug-logo.bc95bec5.png";